import React from "react";

import i1 from "../img/examples/IMG_0054.jpg";
import i2 from "../img/examples/IMG_0058.png";
import i3 from "../img/examples/IMG_0060.png";
import i4 from "../img/examples/IMG_0063.jpg";
import i5 from "../img/examples/IMG_0068.jpg";
import i6 from "../img/examples/IMG_5617.jpg";
import i7 from "../img/examples/IMG_5775.jpg";
import OpenAsModalImage from "./OpenAsModalImage";

import examples from "../data/examples/_examples";
import EmbedPreview from "./EmbedPreview";

export default () => (
  <div className="examples">
    <h2>Examples</h2>

    <p>
      These examples were created with Code Sculpture. Many of them are created
      with just 3 or 4 rules, yet create infinitely complex shapes).
    </p>

    {examples.map(({ rules, yOffset }, i) => (
      <EmbedPreview key={i} project={rules} yOffset={yOffset} />
    ))}

    <h2>Screenshots</h2>

    <OpenAsModalImage src={i1} alt="Example Code Sculpture" />
    <OpenAsModalImage src={i2} alt="Example Code Sculpture" />
    <OpenAsModalImage src={i3} alt="Example Code Sculpture" />
    <OpenAsModalImage src={i4} alt="Example Code Sculpture" />
    <OpenAsModalImage src={i5} alt="Example Code Sculpture" />
    <OpenAsModalImage src={i6} alt="Example Code Sculpture" />
    <OpenAsModalImage src={i7} alt="Example Code Sculpture" />

    <h2>More</h2>

    <p>I have an album with some more examples</p>

    <a
      href="https://photos.app.goo.gl/nWXTSzLZB7SL49Xd2"
      className="button-style"
    >
      More examples
    </a>

    <br />
    <br />
    <br />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Examples.js